/** Tipo 52: requirementsfields.value como JSON { id, value } o id plano (legacy). */

export function parseType52StoredValue(raw: unknown): { id: string | null; label: string | null } {
  if (raw == null || raw === '' || raw === 'null') {
    return { id: null, label: null };
  }
  if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) {
    const o = raw as Record<string, unknown>;
    if (o.id != null && o.id !== '') {
      const label =
        o.value != null && o.value !== ''
          ? String(o.value)
          : o.name != null && o.name !== ''
            ? String(o.name)
            : null;
      return { id: String(o.id), label };
    }
  }
  const s = String(raw).trim();
  if (!s) {
    return { id: null, label: null };
  }
  if (s.startsWith('{')) {
    try {
      return parseType52StoredValue(JSON.parse(s));
    } catch {
      return { id: s, label: null };
    }
  }
  return { id: s, label: null };
}

export function extractType52Id(raw: unknown): string | null {
  return parseType52StoredValue(raw).id;
}

export function extractType52Label(raw: unknown): string | null {
  return parseType52StoredValue(raw).label;
}

export function serializeType52ForStorage(
  selectedId: unknown,
  fieldDef?: { values?: Array<{ id?: unknown; name?: string }> } | null
): string {
  if (selectedId == null || selectedId === '' || selectedId === 'null') {
    return '';
  }
  const parsed = parseType52StoredValue(selectedId);
  const id = parsed.id ?? String(selectedId);
  let label = parsed.label;
  if (!label && fieldDef?.values && Array.isArray(fieldDef.values)) {
    const hit = fieldDef.values.find((o) => o && String(o.id) === String(id));
    if (hit?.name != null) {
      label = String(hit.name);
    }
  }
  return JSON.stringify({ id, value: label ?? id });
}
